import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.continueButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
        span {
            color: #FFFFFF;
        }
    `,
}

headerStyles.addToListButton = {
    mergeCss:true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        margin-left: 10px;
        background: #FFFFFF;
    `,
}

headerStyles.narrowOverflowMenu = {
    cssOverrides:{
        wrapper: css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF;
            }
        `,
    }
}

orderConfirmationAccountSignUpMessageStyles.createAccountButton = {
    mergeCss:true,
        css: css`
            margin-left: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex: 0 0 auto;
                        `,
                    ],
                    "min",
                )}
        `,
}

orderConfirmationBillingInformationStyles.billingInformationCreditCardAddressGridItem = {
    width: [6, 6, 4, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
        display:none;
    `,
}